import { render, staticRenderFns } from "./OsRequestPasswordResetForm.vue?vue&type=template&id=4643893c&scoped=true"
import script from "./OsRequestPasswordResetForm.vue?vue&type=script&lang=ts"
export * from "./OsRequestPasswordResetForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4643893c",
  null
  
)

export default component.exports